import { BaseEntity } from "../base/base.entity";
import { BaseService } from "../base/base.service";
import { AppService } from "../main/app.service";

export class IEmployeeAvailability extends BaseEntity {
    start: any;
    end: any;
    availabilityStatusId: string;
    status: string;
    comment: string;
    employeeId: string;
}

export class EmployeeAvailabilityService extends BaseService<IEmployeeAvailability> {
    constructor(Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'hr/EmployeeAvailability');
    }
}


// WEBPACK FOOTER //
// ./src/app/services/employeeAvailability.service.ts